export default "__VITE_ASSET__ea879407__"